<template>
    <b-modal id="myPrescribeRegModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">개인방제 정보</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><input type="text" class="form_control" v-model="myPrescribeData.prescribe_nm"></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><input type="text" class="form_control" v-model="myPrescribeData.prescribe_source"></td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td>
                                <div class="form_select">
                                <b-form-select v-model="myPrescribeData.prescribe_category" >
                                    <b-form-select-option value="">선택</b-form-select-option>
                                    <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                                </b-form-select>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td>
                                <input
                                    type="text"
                                    class="form_control"
                                    placeholder="입력해주세요"
                                    v-model="myPrescribeData.prescribe_note"
                                />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                 <h3 class="tb_title pb20 pt20">약재 정보</h3>
                <table class="write">
                    <colgroup>
                        <col width="50%">
                        <col width="30%">
                        <col width="20%">
                    </colgroup>
                    <thead>                
                        <tr>                                
                            <th class="bn ac">약재명</th>
                            <th class="bn ac">원산지</th>
                            <th class="bn ac">첩량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in myPrescribeData.medicinelist" :key="index">
                            <td class="ac"><span>{{item.med_hrb_nm}}</span></td>
                            <td class="ac"><span>{{item.org_plce_nm}}</span></td>
                            <td class="ac"><span>{{item.chupCnt}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_reg_confirm()" class="btn btn_md btn_brown">저장</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
        <AlertModal 
            :id="'alert'"
            :text="'저장되었습니다.'" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="alertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        /> 
        <AlertModal 
            :id="'confirm'"
            :text="'저장하시겠습니까?'" 
            :btnLeft="'취소'" 
            :btnRight="'확인'" 
            :oneBtn="true"
            :isShow="comfirmAlertShow"
            :className="'btn_brown'"
            @callback="fn_alert_close"
        />
    </b-modal>

</template>

<script>
    import AlertModal from "@/modal/admin/alertModal.vue"
    import commonUtil from "@/mixin/commonUtil";
    import axios from 'axios'

    export default {
        name: 'myPrescribeRegModal',
        components: {
            AlertModal    
        },
        mixins: [commonUtil],
        props: {
            title: String,
            myPrescribeData : {
                clinic_doctor_id : '',
                prescribe_nm : '',
                prescribe_source : '',
                prescribe_category : '',
                prescribe_note : '',
                medicinelist : [],
            },
        },
        data() {
            return {
                comfirmAlertShow : false,
                alertShow : false,
                prescrbeCategoryList : []    
            };
        },
        async created(){
            this.prescrbeCategoryList = await this.getCode('GC00000015'); 
        },
        methods: {
            fn_reg_confirm(){
                this.comfirmAlertShow = true;
            },
            fn_alert_close(type){
                
                console.log("@@@@ type : "+type);

                if(type == 'hide'){
                    this.comfirmAlertShow = false;                       
                }else if(type == 'ok'){
                    this.comfirmAlertShow = false;
                
                    axios
                        .post("/api/user/appliction/regMyAppication", this.myPrescribeData)
                        .then((res) => {
                            this.alertShow = true;
                        })
                        .catch((err) => console.log(err));
                    }else if(type == 'close'){
                        this.alertShow = false;
                        this.$bvModal.hide("myPrescribeRegModal"); 
                    }
            },                      
        }
    }
</script>

<style>

</style>